<template>
  <fragment>
    <div class="table-wrapper">
      <div class="btn-all" v-if="$route.name != 'accountStatementDetails'">
        <el-button size="98" class="d5" @click="openExportPop" v-permission:export="$route.meta.permission">
          导出
        </el-button>
      </div>
      <slot :tableData="tableData" :handleSelectionChange="handleSelectionChange" :jumpRoute="jumpRoute" />
      <Pagination ref="pagination" v-if="pagination.recordTotal > 1" :currentPage="pagination.currentPage"
        :totalPage="pagination.pageTotal" :totalRecord="pagination.recordTotal" @handleNextPage="nextPage"
        @handlePrevPage="prevPage" @handleJumpPage="jumpPage" @handleChangePageSize="changePageSize" />
    </div>
    <Export ref="excel" :funcName="excelProps.func" :id="multipleSelection" :excelName="excelProps.name" />
  </fragment>
</template>
<script>
import tableOpearting from 'mixins/tableOpearting'

export default {
  name: 'TabaleComponent',
  mixins: [tableOpearting],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => {
        return {}
      }
    },
    routeName: {
      type: String
    },

  },
  computed: {
    excelProps() {
      switch (this.routeName) {
        case 'accountStatement':
          return {
            name: '对账单',
            func: 'exportAccountment'
          }
        case 'accountStatementDetails':
          return {
            name: '对账单详情',
            func: 'exportAccountStatementDetails'
          }
        case 'orderExpert':
          return {
            name: '订单列表(财务)',
            func: 'exportFinanceOrder'
          }
        case 'distributorCommission':
          return {
            name: '分销商佣金',
            func: 'exportCommissionWithdrawal'
          }
        default:
          return {
            func: '',
            name: ''
          }
      }
    }
  },
  methods: {
    /**
     * 父子组件通信
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      const refs = vm.$refs.search
      let condition
      if (refs) condition = refs._returnSearchConditon()
      const data = {
        curpage: newValue,
        pageSize: size
      }
      switch (this.routeName) {
        case 'accountStatement':
          if (vm.i !== 0) {
            data.bill_source = vm.i
          }
          vm._getAccountStatementList({
            ...data,
            ...condition
          })
          break
        case 'accountStatementDetails':
          data.bill_id = this.$route.query.id
          data.reconciliation_status = 2
          vm._getAccountStatementOrder(data)
          break
        case 'distributorCommission':
          data.search_model = 'distributor'
          vm._getFinanceOrderList({ ...data, ...condition })
          break
        case 'accountStatementLog':
          data.bill_id = this.$route.query.id
          vm._getAccountStatementLogList(data)
          break
        case 'invoiceManagement':
          data.search_model = 'invoice'
          vm._getFinanceOrderList({ ...data, ...condition })
          break
        case 'orderExpert':
          data.search_model = 'expert'
          vm._getFinanceOrderList({ ...data, ...condition })
          break
      }
    },
    /**
     * 跳转订单详情
     * @param row
     */
    jumpRoute(row) {
      const { goodsType, orderState, appletsName } = row
      const name = goodsType === '1' ? '跨境订单' : '完税订单'
      this.$router.push({
        name: 'orderDetails',
        query: {
          id: row.orderId,
          title: `${name} / 订单详情 / ${this.utils._orderState(orderState)}`,
          orderAttribution: appletsName
        }
      })
    }
  }
}
</script>
